import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c88af1ec&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c88af1ec&scoped=true&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=c88af1ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88af1ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88af1ec')) {
      api.createRecord('c88af1ec', component.options)
    } else {
      api.reload('c88af1ec', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c88af1ec&scoped=true", function () {
      api.rerender('c88af1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product-sup/inquiryQuotationProduct/detail.vue"
export default component.exports